'use strict';

angular.module('licensure.services')
    .factory('Vehicles', ['$http', '$q', function ($http, $q) {
        var get = function (args) {
            var d = $q.defer();

            $http
                .get(apiLocation + '/api/vehicles', {
                    params: args
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    console.log(response.data);
                    // handle error
                });

            return d.promise;
        }

        var getByID = function (id, getLess) {
            var d = $q.defer();

            $http
                .get(apiLocation + '/api/vehicles/' + id, {
                    params: {
                        getLess: getLess
                    }
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

            return d.promise;
        }

        var getCertificationByNumber = function (number, vehicleID) {
            var d = $q.defer();

            $http
                .get(apiLocation + '/api/certifications', {
                    params: {
                        isVehicle: true,
                        vehicleID: vehicleID,
                        number: number
                    }
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

            return d.promise;
        }

        var getVehicleBySerialNumber = function (number, vehicleID) {
            var d = $q.defer();

            $http
                .get(apiLocation + '/api/vehicles/serialNumberCheck', {
                    params: {
                        vehicleID: vehicleID,
                        number: number
                    }
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

            return d.promise;
        }


        return {
            get: get,

            getByID: getByID,

            getCertificationByNumber: getCertificationByNumber,

            getVehicleBySerialNumber: getVehicleBySerialNumber,

            search: function (args, timeout) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/vehicles/search', {
                        params: args,
                        timeout: (timeout != null ? timeout.promise : null)
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.resolve(response.data);
                    });

                return d.promise;
            },


            searchVehiclesNotInService: function (args, timeout) {
                var d = $q.defer();

                if (args.search === null || args.search === undefined) {
                    //If there is no search, it will return null anyway.
                    //So avoid unnecessary calls to the backend
                    d.resolve(null);
                }
                else {
                    $http
                        .get(apiLocation + '/api/vehicles/searchVehiclesNotInService', {
                            params: args,
                            timeout: (timeout != null ? timeout.promise : null)
                        })
                        .then(function (response) {
                            d.resolve(response.data);
                        })
                        .catch(function (response) {
                            d.resolve(response.data);
                        });
                }

                return d.promise;
            },

            searchByService: function (args, timeout) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/vehicles/searchByService', {
                        params: args,
                        timeout: (timeout != null ? timeout.promise : null)
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.resolve(response.data);
                    });

                return d.promise;
            },

            getVehiclesTypesWithTypeRestriction: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/vehicles/getVehiclesTypesWithTypeRestriction', {
                        params: {
                            limit_vehicle_type_ids: args.limit_vehicle_type_ids,
                            show_vehicles_without_type: args.show_vehicles_without_type
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.resolve(response.data);
                    });

                return d.promise;
            },
        }
    }])
;